export enum SIGNUP_SUCCESS_TEST_IDS {
    REGISTER_SUCCESS_CONTINUE_BUTTON = 'register_success_continue_button',
}
